import { Divider, List } from "@chakra-ui/react"
import React from "react"
import { ServiceFragment } from "../../graphql"
import { ServiceListItem } from "./ServiceListItem"

export type ServicesListProps = {
	services: ServiceFragment[]
}

export const ServicesList: React.FC<ServicesListProps> = ({ services }) => {
	return (
		<List spacing={2}>
			{services.map((service) => (
				<>
					<ServiceListItem key={service._id} service={service} />
					<Divider />
				</>
			))}
		</List>
	)
}
